import { Tuple } from "components/Shared/Interfaces"
import { COMMA_SEPARATOR } from "components/Shared/GlobalFilter/constants"
import { titleCapitalize } from "helpers/text"
import { ALL_CODE, ALL_NAME } from "helpers/service"

const renderCurrentFilter = (filters: Array<Tuple>, codeLabels?: boolean) =>
	filters.find((item) => item.code === ALL_CODE)
		? ALL_NAME
		: filters
				.map(({ name }) =>
					titleCapitalize(
						codeLabels ? name.substring(name.indexOf(" ") + 1) : name
					)
				)
				.join(COMMA_SEPARATOR)

const disabledConditions = (conditions: Array<boolean>) => {
	return conditions.reduce((prev, curr) => prev || curr)
}

export { renderCurrentFilter, disabledConditions }
